import { AppModules } from 'appContainer/types';
import { stringParam } from 'router/declarative/paramRegistry';
import type { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

/**
 * Kept as a string because `parseTourLaunchParams` in `@ardoq/product-tours`
 * owns validation across every app that hosts the engine.
 */
const stepParam = stringParam;

export const routes = {
  path: '/product-tour',
  title: 'Product tour',
  appModule: AppModules.PRODUCT_TOUR,
  children: [
    {
      path: { layout: true },
      children: [
        {
          path: '/:tourId',
          searchParams: { step: stepParam },
          content: async (): PathRouteContent =>
            (await import('./StartTourFromUrlPage')).StartTourFromUrlPage,
        },
      ],
    },
  ],
} as const satisfies RouteNode;
